var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4904 10.171C45.0715 2.80027 31.0795 4.17452 23.1534 12.2296C14.9882 20.5269 14.1505 36.6585 24.0949 44.5673C29.8438 49.1395 39.5931 51.7656 46.882 49.623C60.4705 45.6297 67.5589 29.0377 59.9577 16.0863",
    stroke: "#F9F8F8",
    strokeWidth: 2.3462,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.683 48.1067C48.4303 49.3214 45.8463 49.9177 44.6758 50.1164C45.7943 54.6312 47.7947 60.0824 49.559 64.3723C50.6602 67.0512 52.0247 69.4984 53.2541 72.1207C54.2263 74.1957 57.1358 76.8599 59.0778 74.1125C60.5644 72.01 59.2806 68.8052 58.5507 66.6579C56.5355 60.7242 53.023 53.8894 50.683 48.1067Z",
    fill: "#F9F8F8",
    stroke: "#F9F8F8",
    strokeWidth: 2.3462,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6381 15.9904C43.0299 15.98 44.5079 16.2946 45.8314 16.9123C47.3125 17.6036 48.6002 18.6746 49.3567 20.0944",
    stroke: "#F9F8F8",
    strokeWidth: 2.3462,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.b65fa5b9ab591cd0a0c89cc6b6e2f1b3.svg";
export { ForwardRef as ReactComponent };